(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('TagFactory', TagFactory);

    TagFactory.$inject = ['$resource'];

    function TagFactory($resource) {
        var resourceTag =  'admin/api/tag';
        var resourceFindTags = resourceTag + '/find'
        var resourceDeleteTag = resourceTag + '/:tagId';

        return $resource(resourceTag, {}, {

            'createTag': {
                method: 'POST',
                url: resourceTag,
            },
            'getTagsByStore':{
                method: 'GET',
                url: resourceTag,
                params: {
                    search: '@search'
                },
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'findTagsByStore':{
                method: 'GET',
                url: resourceFindTags,
                isArray: true,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deleteTag': {
                method: 'DELETE',
                url: resourceDeleteTag

            }
        });
    }

})();
